import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { HomeSliderFormComponent } from "./home-slider-form/home-slider-form.component";

const routes: Routes = [
  {
    path: "home-slider",
    component: HomeSliderFormComponent,
    canActivate: [AuthGuard],
  },
];

export const HomeSliderRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/home-slider.routes.ts